const i18nService = {
  languages: [
    {
      lang: "tr",
      name: "Türkçe"
    },
    {
      lang: "en",
      name: "English"
    },
    {
      lang: "nl",
      name:"Dutch"
    }
  ],
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },
};

export default i18nService;
